import { render, staticRenderFns } from "./AdminRain.vue?vue&type=template&id=16d82738&scoped=true"
import script from "./AdminRain.vue?vue&type=script&lang=js"
export * from "./AdminRain.vue?vue&type=script&lang=js"
import style0 from "./AdminRain.vue?vue&type=style&index=0&id=16d82738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d82738",
  null
  
)

export default component.exports